export const BASE_URL =
  process.env.REACT_APP_BASE_URL;

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID;